import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "ui-card__title mb-4" }, " Add custom fields group ", -1)
const _hoisted_2 = { class: "flex gap-4 justify-center" }

import {
	UiButton,
	UiForm,
	UiInput,
	Dialog,
	useForm,
	UiLine
} from '@/ui-kit';
import { useToggle } from '@vueuse/core';
import { required } from '@vuelidate/validators';
import { useCustomFields } from '../composition/use-custom-fields';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddGroupDialog',
  props: {
    order: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	order: number;
};

const { createGroup } = useCustomFields();

const [isOpened, setIsOpened] = useToggle();



const { resetForm, formData, loading, onSubmit } = useForm(
	{
		name: ''
	},
	{
		name: {
			required
		}
	}
);

const submitForm = onSubmit(async (data) => {
	await createGroup({
		...data,
		order: props.order
	}).then(() => setIsOpened(false));
});

expose({
	openDialog: () => {
		resetForm();
		setIsOpened(true);
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    modelValue: _unref(isOpened),
    "onUpdate:modelValue": _unref(setIsOpened),
    preventDefaultClose: _unref(loading)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(UiForm), {
        class: "p-4",
        onSubmit: _unref(submitForm)
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_unref(UiInput), {
            label: "Group name",
            disabled: _unref(loading),
            modelValue: _unref(formData).name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).name) = $event)),
            name: "name"
          }, null, 8, ["disabled", "modelValue"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(UiButton), {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setIsOpened)(false))),
              class: "!h-10 text-sm !min-w-32 !w-32",
              theme: "secondary",
              disabled: _unref(loading)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancel ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(UiButton), {
              class: "!h-10 text-sm !min-w-32 !w-32",
              theme: "primary",
              loading: _unref(loading)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Submit ")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue", "preventDefaultClose"]))
}
}

})